// MaskCpfCnpj.jsx
const MaskCPFCNPJ = (value, target, type) => {
  // normaliza entrada
  const raw = String(value ?? '');
  if (raw.match(/[A-Za-z]+/) && target) {
    target.placeholder = 'Apenas números';
  }

  // só dígitos
  const input = raw.replace(/\D/g, '');
  if (!input) return '';

  const maskCPF = (digits) =>
    digits
      .slice(0, 11)
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3}\.\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3}\.\d{3}\.\d{3})(\d{1,2}).*/, '$1-$2');

  const maskCNPJ = (digits) =>
    digits
      .slice(0, 14)
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{2}\.\d{3})(\d)/, '$1.$2')
      .replace(/(\d{2}\.\d{3}\.\d{3})(\d)/, '$1/$2')
      .replace(/(\d{2}\.\d{3}\.\d{3}\/\d{4})(\d{1,2}).*/, '$1-$2');

  if (type === 'cpf') return maskCPF(input);
  if (type === 'cnpj') return maskCNPJ(input);

  // auto: decide pelo tamanho
  return input.length <= 11 ? maskCPF(input) : maskCNPJ(input);
};

export default MaskCPFCNPJ;